import React, { useState } from "react";
import classes from "./VisitListComponent.module.scss";
import "./TermsandConditionPopup.scss";
import dictionary from "i18next";
import VISA_LOGO from "../../assets/black/vbm_blk.png";
import close from "../../assets/close-black.png";

const VisitListComponent = ({ fields }) => {
  const [ids, setIds] = useState("false");

  React.useEffect(() => {
    let componentId = sessionStorage.getItem("scrollComponentId");
    if (componentId) {
      let element = document.getElementById(componentId);
      const y =
        element && element.offsetTop
          ? this.state.width <= 767
            ? element.offsetTop + element.scrollHeight / 1
            : element.offsetTop - element.scrollHeight / 1
          : 0;
      window.scroll({
        top: y,
        behavior: "smooth",
      });
      sessionStorage.removeItem("scrollComponentId");
    } else {
      window.scroll(0, 0);
    }
  }, []);
  return (

    <div className={classes.visitListWrapper}>
      {fields["Experience List"] &&
        fields["Experience List"].length > 0 &&
        fields["Experience List"].map((item, index) => {
          return (
            <div
              style={index % 2 !== 0 ? { flexFlow: "row-reverse" } : {}}
              className={classes.visitCard}
            >
              <div
                style={{
                  backgroundImage: `url(${
                    item.fields["Visit Image"] &&
                    item.fields["Visit Image"].value &&
                    item.fields["Visit Image"].value.src
                  })`,
                }}
                className={classes.visitHero}
              ></div>
              <div className={classes.visitContent}>
                <div className={classes.visitContentBox}>
                  <h2
                    dangerouslySetInnerHTML={{
                      __html:
                        item.fields["Visit Title"] &&
                        item.fields["Visit Title"].value,
                    }}
                  ></h2>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: item.fields["Visit Description"].value,
                    }}
                  ></span>
                  {
                    item.fields["Visit TC"] && item.fields["Visit TC"].value && (
                    //  <button type="button" class="btn btn-primary"  id={item.id} data-toggle="modal" data-target={"#"+item.id} onClick={(e)=> setIds(e.target.id)}>
                    //   {dictionary.t("Common-FullTermsAndConditionsApply", "")}
                    //   </button>
                    <>                     
                      <span id={item.id} style={{ cursor: "pointer", color: "#7C6F55",fontWeight:"bold" }} onClick={(e)=> setIds(e.target.id)}>
                        {dictionary.t("Common-FullTermsAndConditionsApply", "")}
                      </span>
                      <div class="terms-cond-popup">
                        <div class={ids===item.id ? "modal fade show d-block private-modal" : "modal fade"} id={item.id} tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">{dictionary.t("Common-FullTermsAndConditionsApply", "")}</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"onClick={(e)=> setIds("")}>
                                    <img width="100%" height="100%" src={close} alt="close"></img>
                                </button>
                              </div>
                              <div class="modal-body">
                              <div dangerouslySetInnerHTML={{ __html: item.fields["Visit TC"] && item.fields["Visit TC"].value}}></div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class={ids===item.id ? "backdrop d-block" : "backdrop"} id={item.id}></div>
                      </div>
                    </>
                  )}
                  <br />
                  {
                    window.location.pathname.includes("visa") && (
                    <>
                      <img
                        src={VISA_LOGO}
                        style={{ margin: "15px 0px" }}
                        width="120px"
                        height="40px"
                      ></img>
                      <br />
                    </>
                  )}
                  <br />
                  {
                        item.fields["Visit CTA"] && item.fields["Visit CTA"].value && item.fields["Visit CTA"].value.href && (
                        <a
                            className={classes.visitctabutton}
                            href={item.fields["Visit CTA"].value.href}
                        >
                        {item.fields["Visit CTA Text"].value}
                        </a>
                  )}
                </div>
              </div>
              {/* {showModal && (
                <ModalWrapper
                  isOpen={showModal}
                  title={dictionary.t("Common-FullTermsAndConditionsApply", "")}
                  content={
                    item.fields["Visit TC"] && item.fields["Visit TC"].value
                  }
                  onCancel={() => {
                    setShowModal(false);
                  }}
                  onConfirm={() => {}}
                  showButtons={false}
                />
              )} */}
            </div>
          );
        })}
        <div class="backdrop"></div>
    </div>
                      
  );
};

export default VisitListComponent;
